import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";

import { celleraTheme } from "./muiTheme";

/**
 * Cellera Theme Provider
 * Wraps your app with Material-UI theme and baseline styles
 */
interface CelleraThemeProviderProps {
  children: React.ReactNode;
}

export const CelleraThemeProvider: React.FC<CelleraThemeProviderProps> = ({
  children,
}) => {
  return (
    <ThemeProvider theme={celleraTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default CelleraThemeProvider;
